export default "__VITE_ASSET__be2cffb3__"